import Modal from 'react-modal'
import { modalStyles } from 'pages/styles'
import { Box, Heading } from 'theme-ui'
import { forwardRef } from 'react'
export type FormModalProps = {
  heading: string
  SubHeading?: JSX.Element | JSX.Element[]
  children: JSX.Element | JSX.Element[]
}

export const FormModal = forwardRef<HTMLDivElement, FormModalProps>(
  ({ heading, SubHeading, children }, ref) => {
    return (
      <Modal isOpen style={modalStyles} ariaHideApp={false}>
        <Box
          sx={{
            pt: [0, 55],
            bg: ['white', 'unset'],
            width: '100vw',
            height: '100vh',
            overflow: 'auto',
          }}>
          <Box
            data-cy="form-modal"
            ref={ref}
            sx={{
              position: 'relative',
              pt: [38, 67],
              pl: [0, 60],
              pr: [0, 20],
              pb: [30, 60],
              width: [375, 660],
              margin: 'auto',
              backgroundColor: 'white',
              borderRadius: [0, 15],
            }}>
            <Box
              variant={`forms.section.header`}
              sx={{
                pt: 0,
                pb: 40,
                m: ['auto', 'unset'],
                maxWidth: [335, 'unset'],
              }}>
              <Heading
                variant="forms.h1"
                sx={{ pb: 16, lineHeight: '22px', fontSize: ['22px', '32px'] }}>
                {heading}
              </Heading>
              <Box>{SubHeading}</Box>
            </Box>
            {children}
          </Box>
        </Box>
      </Modal>
    )
  }
)
